// https://github.com/angular/material2/blob/521b111f4a8a735c48109293c937bff848c636ec/src/cdk/coercion/boolean-property.ts
export function coerceBooleanProperty(value: any): boolean {
    return value != null && `${value}` !== 'false';
}
